<template>
    <div>
        <nav class="navbar navbar-expand-md navbar-dark fixed-top py-0">
            <button class="navbar-toggler border-none mx-3 mb-2 mt-1" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
            <img src="@/assets/img/logo.svg" width="150" class="mx-3 mb-2 mt-1" alt="Logo" />
            <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <ul class="navbar-nav mr-auto">
                    <li v-if="canSee('FIT')" class="nav-item" :class="{'bold': $route.name == 'FIT'}">
                        <a class="nav-link" @click="$router.push({name: 'FIT'})">
                            <span class="mr-2  d-lg-inline">
                                FIT
                            </span>
                        </a>
                    </li>
                    <li v-if="canSee('GROUPS')" class="nav-item" :class="{'bold': $route.name == 'GROUPS'}">
                        <a class="nav-link" @click="$router.push({name: 'GROUPS'})">
                            <span class="mr-2  d-lg-inline">
                                GROUPS
                            </span>
                        </a>
                    </li>
                    <li v-if="canSee('PCM')" class="nav-item" :class="{'bold': $route.name == 'PCM'}">
                        <a class="nav-link" @click="$router.push({name: 'PCM'})">
                            <span class="mr-2  d-lg-inline">
                                PCM
                            </span>
                        </a>
                    </li>
                    <li v-if="canSee('users')" class="nav-item" :class="{'bold': $route.name == 'users'}">
                        <a class="nav-link" @click="$router.push({name: 'users'})">
                            <span class="mr-2  d-lg-inline">
                                Users
                            </span>
                        </a>
                    </li>
                    <li v-if="canSee('accessgroups')" class="nav-item" :class="{'bold': $route.name == 'accessgroups'}">
                        <a class="nav-link" @click="$router.push({name: 'accessgroups'})" >
                            <span class="mr-2  d-lg-inline">
                                Access Groups
                            </span>
                        </a>
                    </li>
                    <li v-if="canSee('languages')" class="nav-item" :class="{'bold': $route.name == 'languages'}">
                        <a class="nav-link" @click="$router.push({name: 'languages'})" >
                            <span class="mr-2  d-lg-inline">
                                Languages
                            </span>
                        </a>
                    </li>
                    <li v-if="canSee('bookingforms')" class="nav-item" :class="{'bold': $route.name == 'bookingforms'}">
                        <a class="nav-link" @click="$router.push({name: 'bookingforms'})" >
                            <span class="mr-2  d-lg-inline">
                                Booking Forms
                            </span>
                        </a>
                    </li>
                    <li v-if="canSee('sales')" class="nav-item" :class="{'bold': $route.name == 'sales'}">
                        <a class="nav-link" @click="$router.push({name: 'sales'})" >
                            <span class="mr-2  d-lg-inline">
                                Sales
                            </span>
                        </a>
                    </li>
                    <li v-if="canSee('bookingccs')" class="nav-item" :class="{'bold': $route.name == 'bookingccs'}">
                        <a class="nav-link" @click="$router.push({name: 'bookingccs'})" >
                            <span class="mr-2  d-lg-inline">
                                Currency Rates
                            </span>
                        </a>
                    </li>
                    <li v-if="canSee('image_update')" class="nav-item" :class="{'bold': $route.name == 'image_update'}">
                        <a class="nav-link" @click="$router.push({name: 'image_update'})" >
                            <span class="mr-2  d-lg-inline">
                                Image Update
                            </span>
                        </a>
                    </li>
                    <li v-if="canSee('bookingexpireds')" class="nav-item" :class="{'bold': $route.name == 'bookingexpireds'}">
                        <a class="nav-link" @click="$router.push({name: 'bookingexpireds'})" >
                            <span class="mr-2  d-lg-inline">
                                Booking Expired
                            </span>
                        </a>
                    </li>
                    <li v-if="canSee('trees')" class="nav-item" :class="{'bold': $route.name == 'trees'}">
                        <a class="nav-link" @click="$router.push({name: 'trees'})" >
                            <span class="mr-2  d-lg-inline">
                                Trees
                            </span>
                        </a>
                    </li>
                    <li v-if="canSee('bookingexpireddefault')" class="nav-item" :class="{'bold': $route.name == 'bookingexpireddefault'}">
                        <a class="nav-link" @click="$router.push({name: 'bookingexpireddefault'})" >
                            <span class="mr-2  d-lg-inline">
                                Vencimiento por Defecto
                            </span>
                        </a>
                    </li>

                </ul>

                <ul class="navbar-nav ml-auto">
                    <li class="nav-item dropdown no-arrow">
                        <a v-if="user" class="nav-link dropdown-toggle" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false">
                            <span class="mr-2 d-lg-inline"> {{ user.UserName }} </span>
                            <img class="img-profile rounded-circle" :src="user.Image.url" v-if="user.ImageId">
                        </a>
                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                            <li><a class="dropdown-item cursor-pointer" @click="$router.push({name: 'userProfile'})">
                                <!--font-awesome-icon icon="user" class="fa-sm fa-fw mr-2 text-gray-400"/-->
                                Profile
                            </a></li>
                            <div class="dropdown-divider"></div>
                            <li><a class="dropdown-item cursor-pointer" @click="$router.push({name: 'Logout'})">
                                <!--font-awesome-icon icon="sign-out-alt" class="fa-sm fa-fw mr-2 text-gray-400"/-->
                                Sign out
                            </a></li>
                        </div>
                    </li>            
                </ul>
            </div>
        </nav>
    </div>
</template>

<script>
export default {
    name: 'NavBar',
    data () {
        return {
            collapse: false,
        };
    },
    computed: {
        user () {
            return this.$store.state.user;
        },
        menuPermissions () {
            const ag = this.user && this.user.AccessGroup;
            if (!ag) return {};
            return (ag.permissionsMerge && ag.permissionsMerge.menu)
                || (ag.permissions && ag.permissions.menu)
                || {};
        }
    },
    async mounted () {
    },
    methods: {
        canSee (routeName) {
            return this.menuPermissions[routeName] !== false;
        },
        logout () {
            this.$router.push({name: 'Logout'});
        },
        setRoute (tableName) {
            this.$router.push({ name: 'abm', params: { table: tableName }});
        }
    },
};
</script>

<style scoped>
.dropdown-toggle, .dropdown-toggle:hover, .d-lg-inline {
    color: white;
}
.navbar-collapse {
    background-color: #3283e7;
}
.bold a span {
    font-weight: bold;
    color: #c4c4c4;
}
</style>
